/* tslint:disable */
/* eslint-disable */
/**
 * PRMGApp
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
export var BodyProtocolState;
(function (BodyProtocolState) {
    BodyProtocolState["Clean"] = "Clean";
    BodyProtocolState["Dirty"] = "Dirty";
})(BodyProtocolState || (BodyProtocolState = {}));
export function BodyProtocolStateFromJSON(json) {
    return BodyProtocolStateFromJSONTyped(json, false);
}
export function BodyProtocolStateFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function BodyProtocolStateToJSON(value) {
    return value;
}
